module.exports = __webpack_public_path__ + "static/img/ent-39.abd7423.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-39.jpg
// module id = /XHc
// module chunks = 52